const initialState = {
  collections: [],
  permissionFlags: null,
  enableCollectionMapping: false,
  inMemoryCollections: [],
  externalApiData: null,
  externalApis: [],
  externalDatabase: [],
  totalExternalApisPages: 0,
  loadExternalApisPending: false,
  loadExternalApisError: null,
  deleteExternalApiPending: false,
  deleteExternalApiError: null,
  createExternalApiPending: false,
  createExternalApiError: null,
  updateExternalApiPending: false,
  updateExternalApiError: null,
  loadExternalApiPending: false,
  loadExternalApiError: null,
  loadCollectionsPending: false,
  loadCollectionsError: null,
  loadInMemoryCollectionPending: false,
  loadInMemoryCollectionError: null,
  sendMockDataRequestPending: false,
  sendMockDataRequestError: null,
  loadApiLogsError: null,
  cloneExternalApiPending: false,
  cloneExternalApiError: null,
  loadExternalDatabasePending: false,
  loadExternalDatabaseError: null,
  updateExternalApiTypePending: false,
  updateExternalApiTypeError: null,
  getPermissionFlagsPending: false,
  getPermissionFlagsError: null,
};

export default initialState;
